import React from "react"
import styled from "styled-components"
import { MELOGY_WHITE } from "../../../style/colors"
import { FONT_SIZE_2XS } from "../../../style/fontSettings"

const Text = styled.div`
    width: min(calc(80vw - 32px - 16px), calc(480px - 32px - 16px));
    font-size: ${FONT_SIZE_2XS};
    letter-spacing: 0.2px;
    color: ${MELOGY_WHITE};
    user-select: none;
`

const EmptySpace = styled.div`
    width: min(calc(80vw - 32px - 16px), calc(480px - 32px - 16px));
    height: 16px;
`

const AboutPopoverContent = () => {
    const videoRef = React.useRef(null)

    const togglePlay = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play()
            } else {
                videoRef.current.pause()
            }
        }
    }

    return (
        <>
            <Text>
                I'm Mikko Virtala, a programmer and composer from Helsinki.
            </Text>
            <EmptySpace />
            <Text>
                Melogy is a music generation tool. It uses a combination of user
                input, algorithmic randomization, and music theory to create
                unique compositions.
            </Text>
            <EmptySpace />
            <Text>
                The goal of Melogy is to simplify the exploration and creation
                of new musical styles. It's a practical tool for both music
                enthusiasts and creators, offering an intuitive platform for
                musical experimentation.
            </Text>
            <EmptySpace />
            <Text>
                All music generated and downloaded through Melogy is fully yours
                to use and adapt in any way you see fit.
            </Text>
            <EmptySpace />
            <Text style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                Attributions
            </Text>
            <EmptySpace />
            <Text>
                <strong>Background Images:</strong>
            </Text>
            <Text style={{ marginLeft: '16px', fontSize: '0.85em' }}>
                <strong>Unsplash:</strong> Background images provided by Unsplash (unsplash.com).
                All images are free for commercial use with no attribution required.
            </Text>
            <EmptySpace />
            <Text style={{ marginLeft: '16px', fontSize: '0.85em' }}>
                <strong>ESA/Hubble:</strong> Some background images are provided by ESA/Hubble.
                Licensed under Creative Commons Attribution 4.0 International.
                Credit: ESA/Hubble
                <br />
                <a href="https://esahubble.org/copyright/" target="_blank" rel="noopener noreferrer" style={{ color: '#4dabf7', textDecoration: 'underline' }}>
                    https://esahubble.org/copyright/
                </a>
            </Text>
            <EmptySpace />
            <Text>
                <strong>Sound Libraries:</strong>
            </Text>
            <Text style={{ marginLeft: '16px', fontSize: '0.85em' }}>
                <strong>Piano Salamander:</strong> Salamander Grand Piano v3 by Alexander Holm.
                Licensed under Creative Commons Attribution 3.0.
                <br />
                <a href="https://github.com/sfzinstruments/SalamanderGrandPiano" target="_blank" rel="noopener noreferrer" style={{ color: '#4dabf7', textDecoration: 'underline' }}>
                    https://github.com/sfzinstruments/SalamanderGrandPiano
                </a>
            </Text>
            <EmptySpace />
            <Text style={{ marginLeft: '16px', fontSize: '0.85em' }}>
                <strong>VSCO 2 Community Edition:</strong> Samples by Versilian Studios / Sam Gossner.
                Free for commercial use. Credit to Versilian Studios/Sam Gossner.
                <br />
                <a href="https://vis.versilstudios.net/vsco-2.html" target="_blank" rel="noopener noreferrer" style={{ color: '#4dabf7', textDecoration: 'underline' }}>
                    https://vis.versilstudios.net/vsco-2.html
                </a>
            </Text>
            <EmptySpace />
            <Text style={{ marginLeft: '16px', fontSize: '0.85em' }}>
                <strong>Cello Samples:</strong> Cello samples by flcellogrl from Freesound.
                Licensed under Creative Commons Attribution 3.0.
                <br />
                <a href="https://freesound.org/people/flcellogrl/packs/12408/" target="_blank" rel="noopener noreferrer" style={{ color: '#4dabf7', textDecoration: 'underline' }}>
                    https://freesound.org/people/flcellogrl/packs/12408/
                </a>
            </Text>
        </>
    )
}

export default AboutPopoverContent
